import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '../../ui/Card';
import { Button } from '../../ui/Button';
import toast from 'react-hot-toast';

export function PrivacySettings({ settings, onUpdate }) {
  const [formData, setFormData] = useState(settings);

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate(formData);
    toast.success('Privatsphäre-Einstellungen wurden aktualisiert');
  };

  return (
    <Card>
      <CardHeader>
        <h2 className="text-gray-900 dark:text-white text-lg font-semibold">Privatsphäre & Sicherheit</h2>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Profilsichtbarkeit
            </label>
            <select
              value={formData.visibility}
              onChange={(e) => setFormData({ ...formData, visibility: e.target.value })}
              className="w-full px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-dark-hover text-gray-900 dark:text-white focus:ring-2 focus:ring-primary/20 focus:border-primary"
            >
              <option value="public">Öffentlich</option>
              <option value="private">Privat</option>
              <option value="contacts">Nur Kontakte</option>
            </select>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-medium text-gray-900 dark:text-white">Benachrichtigungen</h3>
            
            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={formData.notifications.email}
                onChange={(e) => setFormData({
                  ...formData,
                  notifications: { ...formData.notifications, email: e.target.checked }
                })}
                className="checkbox-custom"
              />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">E-Mail-Benachrichtigungen</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Erhalten Sie Updates per E-Mail</p>
              </div>
            </label>

            <label className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={formData.notifications.push}
                onChange={(e) => setFormData({
                  ...formData,
                  notifications: { ...formData.notifications, push: e.target.checked }
                })}
                className="checkbox-custom"
              />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">Push-Benachrichtigungen</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Erhalten Sie Benachrichtigungen im Browser</p>
              </div>
            </label>
          </div>

          <div className="pt-4 border-t border-gray-100 dark:border-gray-800">
            <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-4">Blockierte Benutzer</h3>
            <div className="space-y-2">
              {formData.blockedUsers?.length > 0 ? (
                formData.blockedUsers.map((user) => (
                  <div key={user.id} className="flex items-center justify-between p-3 rounded-lg bg-gray-50 dark:bg-dark-hover">
                    <div className="flex items-center gap-3">
                      <img src={user.avatar} alt={user.name} className="w-8 h-8 rounded-full" />
                      <span className="text-sm text-gray-900 dark:text-white">{user.name}</span>
                    </div>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setFormData({
                          ...formData,
                          blockedUsers: formData.blockedUsers.filter(u => u.id !== user.id)
                        });
                      }}
                    >
                      Entsperren
                    </Button>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500 dark:text-gray-400">Keine blockierten Benutzer</p>
              )}
            </div>
          </div>

          <div className="flex justify-end">
            <Button type="submit">Einstellungen speichern</Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}